import React from "react";
import { useSelector } from "react-redux";
import { useRouteMatch, useHistory } from "@/compat/router";
import { Box, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import DocumentViewer from "../components/documents/DocumentViewer";
import CardBase from "../components/cards/CardBase";
import { documentTypes } from "../constants/documentConstants";
import useDocuments from "../hooks/queries/useDocuments";
import PageBase from "../components/PageBase";
import stringUtils from "../utils/stringUtils";

const Documents = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const { params } = match;
  const { documentTypeValue } = params;
  const documentType = Object.values(documentTypes).filter(
    (t) => t.value === parseInt(documentTypeValue)
  )[0];

  const { selectedAccount } = useSelector((state: any) => state.account
  );
  
  // The selected account is usually in childExternalIds already.
  const accountExternalIds = [
    ...new Set(
      stringUtils.compactList([
        ...(selectedAccount?.childExternalIds || []),
        selectedAccount?.account?.externalId,
      ])
    ),
  ];

  const { data, isLoading, isError, error } = useDocuments({
    documentType: documentType.value,
    accountExternalIds,
  });
  

  return (
    <PageBase>
      <CardBase
        title="Document Manager"
        isLoading={isLoading}
        isError={isError}
        error={error}
      >
        <Box>
          <Box mb={2}>
            <IconButton
              data-testid="documents-back"
              onClick={() => history.push("/documents")}
            >
              <ArrowBack />
            </IconButton>
          </Box>
          <DocumentViewer
            documentType={documentType}
            data={data}
          />
        </Box>
      </CardBase>
    </PageBase>
  );
};

export default Documents;
